
import {Options, Vue} from "vue-class-component";

import {Organization} from "@/types";
import store from "@/store";
import {getMaskFormat, getMaskInput, globalConfig} from "@/utils";
import {useRoute} from "vue-router";
import i18n from "@/i18n";
import {isValidEmail} from "@/utils/configuration/input-rules";

@Options({
  methods: {
    isValidEmail,
    getBirthplaceDisplay(c:any) {
      if(c && c.businessData){
        const city = c.businessData.birthplaceCity
        const zip = c.businessData.birthplaceZipCode
        return city && zip ? `${zip} - ${city}` : ''
      }
    },

    getBirthplaceCountryDisplay(c: any) {
      const code = c?.businessData?.birthplaceCountry;
      if (!code) return '';
      if (code.length <= 3) {
        return i18n.global.t('demand.party.country.' + code);
      }
      return code;
    },

    onBirthplaceChange(c:any, selectedValue:any) {
      const selected = this.postalCodes.find((opt:any) => opt.value === selectedValue)
        || this.postalCodes.find((opt:any) => opt.label === selectedValue);
      if (selected?.config) {
        c.businessData.birthplaceZipCode = selected.config.postal_code;
        c.businessData.birthplaceCity = selected.config.city;
        const countryCode = selected.config.country?.id || selected.config.country?.value;
        if (countryCode) {
          c.businessData.birthplaceCountry = countryCode;
        }
      }
    },
    getResidenceDisplay(c:any) {
      if(c && c.businessData){
        const city = c.businessData.city
        const zip = c.businessData.zipCode
        return city && zip ? `${zip} - ${city}` : ''
      }
    },

    onResidenceChange(c:any, selectedValue:any) {
      const selected = this.postalCodes.find((opt:any) => opt.value === selectedValue)
      if (selected?.config) {
        c.businessData.city = selected.config.city
        c.businessData.zipCode = selected.config.postal_code
      }
    },
},
  props: ["party", "tabPosition"],
  watch: {
    "$store.state.middleOfficeModule.section"(newValue) {
      this.showContactExpense = newValue === `section-contact${this.tabPosition}`;
    },
  },
})
export default class PartyContact extends Vue {
  party?: Organization;
  tabPosition!: number;
  showContactExpense = false;
  maskFormat = getMaskFormat();
  maskInput = getMaskInput();
  value: any;
  country: string = "";

  created() {
    this.correspondentList.forEach((correspondent: any) => {
      this.initializeLegacyCptFields(correspondent)

      if (correspondent.qualificationType !== '' && correspondent.qualificationType?.type?.value !== 'DIRG') return

      const businessData = correspondent.businessData
      if (!businessData) return

      correspondent.contactCorrespondent?.forEach((contact: any) => {
        const mechanism = contact.contactMechanism
        if (!mechanism) return

        const typeId = mechanism.type?.id

        if (typeId === 'PHONE_CONTACT') {
          if (!mechanism.phoneNumber) {
            mechanism.phoneNumber = businessData.phone ?? ''
          }
        } else if (typeId === 'EMAIL_CONTACT') {
          if (!mechanism.emailAddress) {
            mechanism.emailAddress = businessData.email ?? ''
          }
        }
      })

      if (
        businessData.birthplaceCity
        && businessData.birthplaceZipCode
        && !businessData.birthplaceCountry
      ) {
        const birthplaceLabel = `${businessData.birthplaceZipCode} - ${businessData.birthplaceCity}`;
        const matchedBirthplace = this.postalCodes.find(
          (opt: any) => opt.label === birthplaceLabel || opt.value === birthplaceLabel
        );
        const countryCode = matchedBirthplace?.config?.country?.id
          || matchedBirthplace?.config?.country?.value;
        if (countryCode) {
          businessData.birthplaceCountry = countryCode;
        }
      }
    })
  }
  get title() {
    return store.getters["picklistModule/titlesItems"].map((item: any) => {
      return {
        ...item,
        label:
          item.value?.toString() !== ""
            ? i18n.global.t("demand.party.title." + item.value)
            : "",
      };
    });
  }
  isLegacyCpt(value: any) {
    return value?.qualificationType?.type?.value === 'CPT' && !value?.businessData
  }

  normalizeName(value: any) {
    return (value || '').trim().replace(/\s+/g, ' ')
  }

  initializeLegacyCptFields(value: any) {
    if (!this.isLegacyCpt(value)) {
      return
    }

    if (value.__cptNameInput !== undefined || value.__cptFirstNameInput !== undefined) {
      return
    }

    const firstName = this.normalizeName(value?.firstName)
    const familyName = this.normalizeName(value?.familyName)
    const hasDuplicatedName =
      firstName &&
      familyName &&
      firstName.toLocaleLowerCase() === familyName.toLocaleLowerCase()
    const combined = hasDuplicatedName ? firstName : `${firstName} ${familyName}`.trim()
    const parts = combined ? combined.split(' ') : []

    value.__cptNameInput = combined
    value.__cptFirstNameInput = ''
/*
    if (parts.length === 2) {
      value.__cptNameInput = combined
      value.__cptFirstNameInput = ''
      return
    }*/

/*    value.__cptNameInput = firstName
    value.__cptFirstNameInput = familyName*/
  }

  getCorrespondentNameInput(value: any) {
    if (!this.isLegacyCpt(value)) {
      return value?.familyName || ''
    }

    this.initializeLegacyCptFields(value)
    return value.__cptNameInput || ''
  }

  getCorrespondentFirstNameInput(value: any) {
    if (!this.isLegacyCpt(value)) {
      return value?.firstName || ''
    }

    this.initializeLegacyCptFields(value)
    return value.__cptFirstNameInput || ''
  }

  setCorrespondentNameInput(value: any, input: any) {
    const normalized = this.normalizeName(input)

    if (!this.isLegacyCpt(value)) {
      value.familyName = normalized
      return
    }

    value.__cptNameInput = normalized
    this.syncLegacyCptModel(value)
  }
  setCorrespondentFirstNameInput(value: any, input: any) {
    const normalized = this.normalizeName(input)

    if (!this.isLegacyCpt(value)) {
      value.firstName = normalized
      return
    }

    value.__cptFirstNameInput = normalized
    this.syncLegacyCptModel(value)
  }

  syncLegacyCptModel(value: any) {
    if (!this.isLegacyCpt(value)) {
      return
    }

    const nameInput = this.normalizeName(value.__cptNameInput)
    const firstNameInput = this.normalizeName(value.__cptFirstNameInput)

    if (firstNameInput) {
      value.firstName = nameInput
      value.familyName = firstNameInput
      return
    }

    if (!nameInput) {
      value.firstName = ''
      value.familyName = ''
      return
    }

    const parts = nameInput.split(' ')

    if (parts.length === 1) {
      value.familyName = parts[0] || ''
      value.firstName = ''
      return
    }

    value.familyName = parts[0] || ''
    value.firstName = parts.slice(1).join(' ')
  }

  get correspondentList() {
    return (this.party?.correspondents && this.party.correspondents.length > 0)
        ? this.party.correspondents
        : [store.getters['thirdModule/getCorrespondentEmpty']];

  }
  validateBirthDate(birthDate: string) {
    return globalConfig.input_rules.validateBirthDate(birthDate);
  }
  getCodeCity(value: any): string {
    if (!value?.businessData?.zipCode || !value?.businessData?.city) {
      return '';
    }
    return `${value.businessData.zipCode} - ${value.businessData.city}`;
  }
  get countries() {
    return store.getters["picklistModule/countriesItems"];
  }
  get postalCodes() {
    return store.getters["picklistModule/postalCodesItems"];
  }
  qualificationType(index: number) {
    return store.getters["picklistModule/qualificationTypeItems"]
      .filter(
        (o: any) => this.correspondentList[index].qualificationType?.type?.value == o.value
      )
      .map((o: any) => o.label);
  }
  get qualificationTypeOptions() {
    return store.getters["picklistModule/qualificationTypeItems"].map(
      (item: any) => {
        return {
          ...item,
          label:
            item.label?.toString() !== ""
              ? i18n.global.t(
                "middleOffice.party.organization.contact.fonction." +
                item.value
              )
              : "",
        };
      }
    );
  }
  updateQualificationType(correspondent: any, value: any) {
    if (!correspondent.qualificationType) {
      correspondent.qualificationType = { type: {} };
    } else if (!correspondent.qualificationType.type) {
      correspondent.qualificationType.type = {};
    }

    correspondent.qualificationType.type.value = value;

    // Assigner la signature uniquement si DIRG
    correspondent.signingAuthority = (value === 'DIRG') ? true : false;

  }


  get currentRoute() {
    return useRoute().name;
  }
  get isMO() {
    if (this.currentRoute !== 'TaskDetail') {
      return true
    } else
      return false
  }
}
